module.exports = __webpack_public_path__ + "static/img/9.7e3e15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/9.jpg
// module id = reII
// module chunks = 1